import client from './client';

/**
 * 컨버전 일자별 통계
 */
export const conversiondayReport = (param) =>
  client.get(`/api/report/conversion/detail`, param);

/**
 * 컨버전 매체계정벌 리스트
 */
export const conversionListReport = (param) =>
  client.get(`/api/report/conversion/state_list`, param);

/**
 * 컨버전 매체계정벌 리스트
 */
export const audiencePopupDetail = (param) =>
  client.get(`/api/report/datacenter/audience/conversion`, param);

/**
 * 통계보고서 - 컨버전통계 - 전환비교[일자별]
 */
export const conversionComparDaily = (param) =>
  client.get(`/api/report/conversion/compareDaily`, param);

/**
 * 통계보고서 - 컨버전통계 - 전환비교[일자별] - 그래프
 */
export const conversionComparDailyGraph = (param) =>
  client.get(`/api/report/conversion/compareDaily/graph`, { params: param });

/**
 * 통계보고서 - 컨버전통계 - 전환비교[시간별]
 */
export const conversionComparTime = (param) =>
  client.get(`/api/report/conversion/compareTime`, param);

/**
 * 통계보고서 - 컨버전통계 - 전환비교[시간별] - 그래프
 */
export const conversionComparTimeGraph = (param) =>
  client.get(`/api/report/conversion/compareTime/graph`, { params: param });

/**
 * 통계보고서 - 컨버전통계 - 장바구니/찜
 */
export const conversionCartDetail = (param) =>
  client.get(`/api/report/conversion/cartDetail`, param);
